export default __webpack_public_path__ + "media/images/footer/boleto-24975d0d9ff0ae0012f1cc6f21b27388.svg";